import { cn } from "@gymflow/helpers";
import { UseInfiniteQueryResult } from "@tanstack/react-query";

import { Spinner } from "..";

type InfiniteScrollContainerProps = {
  children: React.ReactNode;
  className?: string;
  direction?: "horizontal" | "vertical";
  threshold?: number;
  showSpinner?: boolean;
  query: UseInfiniteQueryResult;
};

export const InfiniteScrollContainer = ({
  children,
  className,
  direction = "vertical",
  threshold = 50,
  showSpinner = true,
  query,
}: InfiniteScrollContainerProps) => {
  const handleScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const el = e.currentTarget;
    if (!el || !query.hasNextPage || query.isFetchingNextPage) return;

    const isNearEnd =
      direction === "horizontal"
        ? el.scrollLeft + el.clientWidth >= el.scrollWidth - threshold
        : el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;

    if (isNearEnd) query.fetchNextPage();
  };

  return (
    <div
      className={cn(className, {
        "overflow-y-auto": direction === "vertical",
        "overflow-x-auto": direction === "horizontal",
      })}
      onScroll={(e) => handleScroll(e)}
    >
      {children}
      {query.isFetchingNextPage && showSpinner && (
        <div className="flex justify-center py-4">
          <Spinner className="size-6" />
        </div>
      )}
    </div>
  );
};
